import { render } from "./Consumables.vue?vue&type=template&id=1ab6f19c"
import script from "./Consumables.vue?vue&type=script&lang=js"
export * from "./Consumables.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__